import { BadgeSize, BadgeVariant } from './types'

export const CONTAINER_SIZES: Record<BadgeSize, string> = {
  sm: 'h-6 w-6',
  md: 'h-8 w-8',
  lg: 'h-10 w-10',
}

export const BADGE_VARIANT_STYLES: Record<BadgeVariant, string> = {
  danger: 'bg-danger-default text-white',
  primary: 'bg-primary-500 text-white',
  success: 'bg-success-default text-white',
  warning: 'bg-warning-default text-white',
}

export const BADGE_SIZE_STYLES: Record<BadgeSize, string> = {
  sm: 'h-4 min-w-4 px-1 text-xs',
  md: 'h-5 min-w-5 px-1.5 text-xs',
  lg: 'h-6 min-w-6 px-2 text-sm',
}
